export type {
  ErrorProps,
  WithErrorProps,
  WrappedComponentProps,
} from './withErrorPage';
export { withErrorPage } from './withErrorPage';
